module.exports = __webpack_public_path__ + "static/media/double-left-caret-white-circle.23891b28.svg";